/* touku-value — unified product-page delivery, rate-of-use calculator, and instant checkout.
   Seamlessly integrates with Shopify's native product form to eliminate redundant dropdowns and duplicate buttons,
   creating a single, frictionless purchase experience.
   Container: <div data-touku-value="{handle}" data-handling-min="1" data-handling-max="2" data-free-min="100"></div>. */
(function () {
  var SB = "https://ffxcakaddzvjxjsnfpbg.supabase.co/functions/v1";
  var el = document.querySelector("[data-touku-value]");
  if (!el) return;
  var handle = el.getAttribute("data-touku-value") || "kaiser-tung-hsieh-touku-balm-plaster";

  var handlingMin = parseInt(el.getAttribute("data-handling-min") || "1", 10);
  var handlingMax = parseInt(el.getAttribute("data-handling-max") || "2", 10);
  var freeShippingMin = parseFloat(el.getAttribute("data-free-min") || "100");

  var REGIONS = [
    {
      name: "Domestic",
      key: "SG",
      countries: [
        { code: "SG", name: "Singapore" }
      ]
    },
    {
      name: "East Asia & Oceania",
      key: "EAO",
      countries: [
        { code: "AU", name: "Australia" },
        { code: "CN", name: "China" },
        { code: "HK", name: "Hong Kong" },
        { code: "JP", name: "Japan" },
        { code: "MO", name: "Macau" },
        { code: "NZ", name: "New Zealand" },
        { code: "KR", name: "South Korea" },
        { code: "TW", name: "Taiwan" }
      ]
    },
    {
      name: "Europe",
      key: "EUR",
      countries: [
        { code: "AT", name: "Austria" },
        { code: "BE", name: "Belgium" },
        { code: "BG", name: "Bulgaria" },
        { code: "HR", name: "Croatia" },
        { code: "CY", name: "Cyprus" },
        { code: "CZ", name: "Czech Republic" },
        { code: "DK", name: "Denmark" },
        { code: "EE", name: "Estonia" },
        { code: "FI", name: "Finland" },
        { code: "FR", name: "France" },
        { code: "DE", name: "Germany" },
        { code: "GR", name: "Greece" },
        { code: "HU", name: "Hungary" },
        { code: "IS", name: "Iceland" },
        { code: "IE", name: "Ireland" },
        { code: "IT", name: "Italy" },
        { code: "LV", name: "Latvia" },
        { code: "LT", name: "Lithuania" },
        { code: "LU", name: "Luxembourg" },
        { code: "MT", name: "Malta" },
        { code: "NL", name: "Netherlands" },
        { code: "NO", name: "Norway" },
        { code: "PL", name: "Poland" },
        { code: "PT", name: "Portugal" },
        { code: "RO", name: "Romania" },
        { code: "SK", name: "Slovakia" },
        { code: "SI", name: "Slovenia" },
        { code: "ES", name: "Spain" },
        { code: "SE", name: "Sweden" },
        { code: "CH", name: "Switzerland" },
        { code: "GB", name: "United Kingdom" }
      ]
    },
    {
      name: "Middle East",
      key: "MEA",
      countries: [
        { code: "BH", name: "Bahrain" },
        { code: "EG", name: "Egypt" },
        { code: "IL", name: "Israel" },
        { code: "JO", name: "Jordan" },
        { code: "KW", name: "Kuwait" },
        { code: "LB", name: "Lebanon" },
        { code: "OM", name: "Oman" },
        { code: "QA", name: "Qatar" },
        { code: "SA", name: "Saudi Arabia" },
        { code: "TR", name: "Turkey" },
        { code: "AE", name: "United Arab Emirates" }
      ]
    },
    {
      name: "North America",
      key: "NAM",
      countries: [
        { code: "CA", name: "Canada" },
        { code: "MX", name: "Mexico" },
        { code: "US", name: "United States" }
      ]
    },
    {
      name: "South Asia",
      key: "SAS",
      countries: [
        { code: "BD", name: "Bangladesh" },
        { code: "IN", name: "India" },
        { code: "NP", name: "Nepal" },
        { code: "PK", name: "Pakistan" },
        { code: "LK", name: "Sri Lanka" }
      ]
    },
    {
      name: "Southeast Asia",
      key: "SEA",
      countries: [
        { code: "BN", name: "Brunei" },
        { code: "KH", name: "Cambodia" },
        { code: "ID", name: "Indonesia" },
        { code: "LA", name: "Laos" },
        { code: "MY", name: "Malaysia" },
        { code: "MM", name: "Myanmar" },
        { code: "PH", name: "Philippines" },
        { code: "TH", name: "Thailand" },
        { code: "VN", name: "Vietnam" }
      ]
    },
    {
      name: "Rest of the World",
      key: "ROW",
      countries: [
        { code: "AR", name: "Argentina" },
        { code: "BR", name: "Brazil" },
        { code: "CL", name: "Chile" },
        { code: "CO", name: "Colombia" },
        { code: "ZA", name: "South Africa" }
      ]
    }
  ];

  var CN = {}, REG = {};
  REGIONS.forEach(function (reg) {
    reg.countries.forEach(function (c) {
      CN[c.code] = c.name;
      REG[c.code] = reg.key;
    });
  });

  var TRANSIT = { SG:[0,1], SEA:[4,9], EAO:[6,12], SAS:[8,16], NAM:[8,18], EUR:[8,18], MEA:[8,16], ROW:[10,25] };
  var wrap = "border:1.5px solid #e4e4e7;background:#ffffff;border-radius:12px;padding:18px;margin:16px 0 20px 0;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:#09090b;box-shadow:0 4px 16px rgba(0,0,0,0.04);";

  var data = null, country = null;
  var UNIT = /plaster|touku|soothe|patch/i.test(handle) ? "patch" : "piece";
  var UNITS = UNIT === "patch" ? "patches" : UNIT + "s";
  var NUTRITION = /protein|whey|creatine|carnitine|bcaa|amino|collagen|vitamin|pre-?workout|mass.?gainer|isotonic|electrolyte|fresubin|glutamine|nutrition/i.test(handle);

  var patchesPerWeek = 3;
  var activeTierIndex = 2; // Default to 50 pcs

  // Cleanly integrate with Shopify native form: hide redundant clunky dropdown & duplicate buttons
  function hideRedundantShopifyFormElements() {
    try {
      var form = document.querySelector('#AddToCartForm-product-template, form[action*="/cart/add"]');
      if (form) {
        var redundantSelectors = form.querySelectorAll('.selector-wrapper, .product-form__item--quantity, .product-form__item--submit');
        redundantSelectors.forEach(function (elem) {
          elem.style.display = 'none';
        });
        if (el.parentNode && el.parentNode !== form && form.parentNode) {
          form.parentNode.insertBefore(el, form);
        }
      }
    } catch (e) {}
  }

  var PLAN_CTA =
    '<div style="border-top:1px dashed #e4e4e7;margin-top:14px;padding-top:12px;font-size:12.5px;">' +
      '🎯 Want the exact daily amount for <b>your</b> body &amp; goals?' +
      '<a href="https://app.crazybadman.com/auth?redirect=%2Fdiet-plan&src=store-calc" target="_blank" rel="noopener" ' +
        'style="display:inline-block;margin-top:6px;background:#EB172B;color:#fff;padding:7px 14px;border-radius:6px;text-decoration:none;font-weight:800;text-transform:uppercase;font-size:11.5px;letter-spacing:0.5px;">' +
        'Get your free personalised plan →</a>' +
      '<div style="color:#71717a;margin-top:5px;">Your first plan is free — enter your stats once and every product knows your amount.</div>' +
    "</div>";

  el.innerHTML = '<div style="' + wrap + 'font-size:13px;">🌏 Calculating delivery &amp; value for your location…</div>';

  Promise.all([
    fetch(SB + "/shipping-estimate").then(function (r) { return r.json(); }).catch(function () { return {}; }),
    fetch(SB + "/landed-cost?handle=" + encodeURIComponent(handle)).then(function (r) { return r.json(); }).catch(function () { return {}; }),
  ]).then(function (res) {
    country = (res[0] && res[0].country) || "SG";
    if (!CN[country]) country = "SG";
    data = res[1] || {};
    if (data.free_shipping_threshold_sgd) freeShippingMin = data.free_shipping_threshold_sgd;
    if (data.handling_days && data.handling_days.length >= 2) {
      handlingMin = data.handling_days[0];
      handlingMax = data.handling_days[1];
    }
    var urlParams = new URLSearchParams(window.location.search);
    var urlVarId = urlParams.get('variant');
    if (urlVarId && data.tiers && data.tiers.length) {
      var foundIdx = data.tiers.findIndex(function(t) { return String(t.id) === String(urlVarId); });
      if (foundIdx !== -1) {
        activeTierIndex = foundIdx;
      }
    }
    render();
  });

  function transit(c) { return TRANSIT[REG[c] || "ROW"] || TRANSIT.ROW; }
  function shipFor(g, bands, c) {
    if (c === "SG") return 5;
    for (var i = 0; i < (bands || []).length; i++) {
      if (g >= bands[i].weight_min_g && g <= bands[i].weight_max_g) return Number(bands[i].charge_sgd);
    }
    return 20;
  }

  function syncWithShopifyNativeForm(variantId, variantTitle) {
    if (!variantId) return;
    try {
      var select = document.querySelector('#ProductSelect-product-template, select[name="id"]');
      if (select) {
        select.value = String(variantId);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var singleOption = document.querySelector('#SingleOptionSelector-0, .single-option-selector');
      if (singleOption && variantTitle) {
        singleOption.value = variantTitle;
        singleOption.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } catch (e) {}
  }

  var NAV_PILLARS = [
    {
      title: "Watch",
      url: "https://app.crazybadman.com/watch",
      items: [
        { title: "Watch Parties & Replays", url: "https://app.crazybadman.com/watch-parties" },
        { title: "Magazine", url: "https://app.crazybadman.com/magazine" },
        { title: "Newsroom", url: "https://app.crazybadman.com/newsroom" },
        { title: "Predictions", url: "https://app.crazybadman.com/predictions" },
        { title: "Find Players", url: "https://app.crazybadman.com/players" },
        { title: "Support Your Country", url: "https://app.crazybadman.com/support/countries" }
      ]
    },
    {
      title: "Play",
      url: "https://app.crazybadman.com/find-game",
      items: [
        { title: "Find Pickup Games", url: "https://app.crazybadman.com/find-game" },
        { title: "Tournament Radar", url: "https://app.crazybadman.com/tournaments" },
        { title: "Global Tournament Calendar", url: "https://app.crazybadman.com/calendar" },
        { title: "SG Court Matchmaking", url: "https://app.crazybadman.com/sg-matchmaking" },
        { title: "Host a Tournament", url: "https://app.crazybadman.com/tournament/create" }
      ]
    },
    {
      title: "Train",
      url: "https://app.crazybadman.com/train",
      items: [
        { title: "Find a Coach", url: "https://app.crazybadman.com/coaches" },
        { title: "Coach Subscriptions", url: "https://app.crazybadman.com/coach-subscription" },
        { title: "Demo Coach Profile", url: "https://app.crazybadman.com/coach/sg/demo-coach" }
      ]
    },
    {
      title: "Eat",
      url: "https://app.crazybadman.com/food-hub",
      items: [
        { title: "Food Hub", url: "https://app.crazybadman.com/food-hub" },
        { title: "AI Diet Plan", url: "https://app.crazybadman.com/ai-plan" },
        { title: "Recipes", url: "https://app.crazybadman.com/recipes" },
        { title: "Food Discovery", url: "https://app.crazybadman.com/discovery" },
        { title: "Fitness Dashboard", url: "https://app.crazybadman.com/fitness" },
        { title: "Wellness Passport", url: "https://app.crazybadman.com/wellness-passport" }
      ]
    },
    {
      title: "Shop",
      url: "https://www.crazybadman.com",
      items: [
        { title: "Pro Shops & Stringers", url: "https://app.crazybadman.com/shops" },
        { title: "Apparel", url: "https://www.crazybadman.com/collections/sports-apparel" },
        { title: "Equipment", url: "https://www.crazybadman.com/collections/sports-equipment" },
        { title: "Supplements", url: "https://www.crazybadman.com/collections/supplements" },
        { title: "Marketplace (Resale)", url: "https://app.crazybadman.com/marketplace" },
        { title: "Sell Your Gear", url: "https://app.crazybadman.com/marketplace/sell" }
      ]
    },
    {
      title: "Gaming",
      url: "https://app.crazybadman.com/gaming",
      items: [
        { title: "Palworld Launch Hub", url: "https://app.crazybadman.com/palworld/servers" },
        { title: "Rent a Private Server", url: "https://app.crazybadman.com/gaming/plans" },
        { title: "Browse Servers", url: "https://app.crazybadman.com/gaming/browse" },
        { title: "My Server Dashboard", url: "https://app.crazybadman.com/gaming/my-server" },
        { title: "Free Discord Safety Bot", url: "https://app.crazybadman.com/discord-bot" },
        { title: "Safety & Verification", url: "https://app.crazybadman.com/safety" }
      ]
    }
  ];

  function syncShopifyNavigation() {
    try {
      var nav = document.getElementById("SiteNav");
      if (!nav) return;
      var html = "";
      NAV_PILLARS.forEach(function (p) {
        var pSlug = p.title.toLowerCase();
        html +=
          '<li class="site-nav__item site-nav__item--no-columns" aria-haspopup="true">' +
            '<a href="' + p.url + '" class="site-nav__link site-nav__link-toggle" id="SiteNavLabel-' + pSlug + '" aria-controls="SiteNavLinklist-' + pSlug + '" aria-expanded="false">' +
              p.title +
              ' <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-down" viewBox="0 0 32 32" style="width:9px;height:9px;display:inline-block;vertical-align:middle;margin-left:3px;"><path fill="#444" d="M26.984 8.5l1.516 1.617L16 23.5 3.5 10.117 5.008 8.5 16 20.258z"/></svg>' +
            '</a>' +
            '<div class="site-nav__dropdown meganav site-nav__dropdown--second-level" id="SiteNavLinklist-' + pSlug + '" aria-labelledby="SiteNavLabel-' + pSlug + '" role="navigation">' +
              '<ul class="meganav__nav page-width">' +
                '<div class="grid grid--no-gutters meganav__scroller--has-list">' +
                  '<div class="grid__item meganav__list one-fifth">';
        p.items.forEach(function (item) {
          html +=
            '<li class="site-nav__dropdown-container">' +
              '<a href="' + item.url + '" class="meganav__link meganav__link--second-level">' +
                item.title +
              '</a>' +
            '</li>';
        });
        html +=
                  '</div>' +
                '</div>' +
              '</ul>' +
            '</div>' +
          '</li>';
      });
      nav.innerHTML = html;

      var drawerNav = document.querySelector("#NavDrawer .drawer__nav");
      if (drawerNav) {
        var dHtml = "";
        NAV_PILLARS.forEach(function (p) {
          dHtml +=
            '<li class="drawer__nav-item">' +
              '<div class="drawer__nav-has-sublist">' +
                '<a href="' + p.url + '" class="drawer__nav-link drawer__nav-link--top-level drawer__nav-link--split">' +
                  p.title +
                '</a>' +
              '</div>' +
            '</li>';
        });
        drawerNav.innerHTML = dHtml;
      }
    } catch (e) {}
  }

  function render() {
    var counted = data && data.sold_by === "piece" && data.tiers && data.tiers.length;
    var yes = country ? "Yes — we ship to " + CN[country] + " ✓" : "Yes — we ship worldwide from Singapore ✓";
    var couponCode = el.getAttribute("data-coupon") || (data && data.free_shipping_coupon) || "TOUKUSHIP";
    var isTouku = /touku/i.test(window.location.pathname) || (data && /touku/i.test(data.slug || data.product_title || ""));
    var hasFreeShip = isTouku && freeShippingMin && freeShippingMin < 99999 && data && (data.free_shipping_threshold_sgd || data.tiers?.some(function(t){ return t.free_shipping || t.price_sgd >= freeShippingMin; }));
    var freeLine = hasFreeShip
      ? '<div id="tk_free_banner" style="background:#fff5f5;border:1.5px dashed #EB172B;padding:9px 12px;border-radius:8px;margin-bottom:10px;font-size:12.5px;line-height:1.45;color:#09090b;transition:all 0.2s ease;">' +
          '<div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:6px;">' +
            '<span id="tk_free_title" style="font-weight:900;color:#EB172B;text-transform:uppercase;letter-spacing:0.3px;">⚡ FREE Worldwide Tracked Shipping (Orders over S$' + Math.round(freeShippingMin) + ')</span>' +
            '<span style="background:#EB172B;color:#ffffff;font-weight:900;padding:2px 8px;border-radius:4px;font-size:11.5px;letter-spacing:0.5px;">AUTO-APPLIED</span>' +
          '</div>' +
          '<div id="tk_free_sub" style="font-size:11.5px;color:#71717a;margin-top:4px;">' +
            '✨ <i>Code <b>' + couponCode + '</b> will be automatically applied at checkout when order reaches S$' + Math.round(freeShippingMin) + '.</i>' +
          '</div>' +
        '</div>'
      : '';

    var rateOfUseBlock = counted
      ? '<div style="border-top:1px solid #f4f4f5;padding-top:10px;margin-top:10px;">' +
          '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;flex-wrap:wrap;gap:4px;">' +
            '<span style="font-size:12.5px;font-weight:800;color:#09090b;">📊 How often do you use a ' + UNIT + '?</span>' +
            '<div style="display:inline-flex;align-items:center;gap:3px;font-size:11.5px;color:#71717a;">' +
              '<span>Custom:</span>' +
              '<input id="tkcustom" type="number" min="1" max="50" value="' + patchesPerWeek + '" style="width:40px;padding:3px 4px;border:1.5px solid #e4e4e7;border-radius:6px;font-size:11.5px;text-align:center;font-weight:700;color:#09090b;" />' +
              '<span>/wk</span>' +
            '</div>' +
          '</div>' +
          '<div id="tkrates" style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:10px;"></div>' +
          '<div style="font-size:12.5px;font-weight:800;color:#09090b;margin-bottom:6px;">🗓️ Desired Supply Duration:</div>' +
          '<div id="tksupplies" style="display:flex;gap:5px;flex-wrap:wrap;margin-bottom:8px;"></div>' +
        '</div>'
      : '';

    var valueBlock = counted
      ? '<div style="border-top:1px solid #f4f4f5;padding-top:12px;margin-top:12px;">' +
          '<div style="font-size:13px;font-weight:800;margin-bottom:8px;color:#09090b;text-transform:uppercase;letter-spacing:0.3px;">Select Quantity &amp; Order:</div>' +
          '<div id="tktiers" style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:10px;"></div>' +
          '<div id="tkcost" style="font-size:13px;line-height:1.5;color:#18181b;"></div>' +
          '<div id="tkcta" style="margin-top:16px;display:flex;gap:8px;flex-wrap:wrap;"></div>' +
        "</div>"
      : '<div id="tkship" style="border-top:1px solid #f4f4f5;padding-top:10px;font-size:13px;color:#18181b;"></div>';

    el.innerHTML =
      '<div style="' + wrap + '">' +
        '<div style="display:flex;gap:8px;align-items:center;font-size:13.5px;margin-bottom:8px;position:relative;">' +
          '<span style="font-weight:800;color:#09090b;white-space:nowrap;">Do you ship to:</span>' +
          '<div style="position:relative;flex:1;">' +
            '<div style="display:flex;align-items:center;position:relative;">' +
              '<input id="tk_country_input" type="text" autocomplete="off" value="' + (CN[country] || "Singapore") + '" placeholder="Type or select country..." style="width:100%;padding:7px 28px 7px 10px;border:1.5px solid #e4e4e7;border-radius:6px;font-size:13px;font-weight:700;color:#09090b;background:#ffffff;box-sizing:border-box;cursor:pointer;" />' +
              '<span style="position:absolute;right:10px;pointer-events:none;color:#71717a;font-size:10px;">▼</span>' +
            '</div>' +
            '<div id="tk_dropdown" style="display:none;position:absolute;top:100%;left:0;right:0;max-height:260px;overflow-y:auto;background:#ffffff;border:1.5px solid #e4e4e7;border-radius:6px;box-shadow:0 8px 24px rgba(0,0,0,0.12);z-index:9999;margin-top:4px;"></div>' +
          '</div>' +
        '</div>' +
        '<div id="tketa" style="font-size:13px;margin-bottom:8px;line-height:1.45;color:#18181b;"></div>' +
        freeLine +
        rateOfUseBlock +
        valueBlock +
        (NUTRITION ? PLAN_CTA : "") +
      "</div>";

    syncTopBanner();
    syncShopifyNavigation();

    if (counted) hideRedundantShopifyFormElements();
    setupSearchableCountryDropdown();

    var customInp = document.getElementById("tkcustom");
    if (customInp) {
      customInp.addEventListener("input", function () {
        var v = parseInt(customInp.value, 10);
        if (v && v > 0) {
          patchesPerWeek = v;
          paintRateButtons();
          paintTiers();
          syncTiers();
        }
      });
    }

    paintEta();
    if (counted) {
      paintRateButtons();
      paintTiers();
    } else {
      paintShip();
    }
  }

  function syncTopBanner() {
    try {
      var banners = document.querySelectorAll('.notification__message, .notification--promo .notification__inner span, .announcement-bar, [data-section-type="announcement-bar"], .notification-bar, .announcement-bar__message, p.announcement-bar__text, [data-text*="we-ship-globally-from-singapore"] .notification__message');
      banners.forEach(function (b) {
        b.innerHTML = '📦 Your shipment is sent out 1st &amp; 15th every month. We save on operations and share the savings with you!';
      });
    } catch (e) {}
  }
  syncTopBanner();
  if (typeof setInterval !== 'undefined') {
    var bannerIntervalCount = 0;
    var bTimer = setInterval(function() {
      syncTopBanner();
      bannerIntervalCount++;
      if (bannerIntervalCount > 20) clearInterval(bTimer);
    }, 250);
  }

  function setupSearchableCountryDropdown() {
    var inp = document.getElementById("tk_country_input");
    var drop = document.getElementById("tk_dropdown");
    if (!inp || !drop) return;

    function renderDropdown(filterText) {
      var q = (filterText || "").toLowerCase().trim();
      var html = "";
      var matchCount = 0;

      REGIONS.forEach(function (reg) {
        var matchingCountries = reg.countries.filter(function (c) {
          return !q || c.name.toLowerCase().includes(q) || c.code.toLowerCase() === q || reg.name.toLowerCase().includes(q);
        });

        if (matchingCountries.length > 0) {
          html += '<div style="background:#f4f4f5;padding:6px 10px;font-size:11px;font-weight:800;color:#71717a;text-transform:uppercase;letter-spacing:0.5px;border-bottom:1px solid #e4e4e7;border-top:1px solid #e4e4e7;">' + reg.name + '</div>';
          matchingCountries.forEach(function (c) {
            matchCount++;
            var isSel = c.code === country;
            html += '<div data-code="' + c.code + '" style="padding:8px 12px;font-size:13px;font-weight:' + (isSel ? "800" : "500") + ';color:' + (isSel ? "#EB172B" : "#18181b") + ';background:' + (isSel ? "#fff5f5" : "#ffffff") + ';cursor:pointer;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #f4f4f5;">' +
              '<span>' + c.name + '</span>' +
              (isSel ? '<span style="color:#EB172B;font-weight:900;">✓</span>' : '') +
            '</div>';
          });
        }
      });

      if (matchCount === 0) {
        html = '<div style="padding:12px;font-size:12.5px;color:#71717a;text-align:center;">No matching countries found.</div>';
      }

      drop.innerHTML = html;

      // Attach item click listeners
      var items = drop.querySelectorAll("[data-code]");
      items.forEach(function (it) {
        it.addEventListener("click", function (e) {
          e.stopPropagation();
          var selCode = it.getAttribute("data-code");
          selectCountry(selCode);
        });
        it.addEventListener("mouseenter", function () {
          if (it.getAttribute("data-code") !== country) it.style.background = "#f4f4f5";
        });
        it.addEventListener("mouseleave", function () {
          if (it.getAttribute("data-code") !== country) it.style.background = "#ffffff";
        });
      });
    }

    function selectCountry(code) {
      if (!code || !CN[code]) return;
      country = code;
      inp.value = CN[code];
      drop.style.display = "none";
      paintEta();
      var counted = data && data.sold_by === "piece" && data.tiers && data.tiers.length;
      if (counted) { paintTiers(); syncTiers(); } else paintShip();
    }

    inp.addEventListener("focus", function () {
      drop.style.display = "block";
      renderDropdown(inp.value === CN[country] ? "" : inp.value);
    });

    inp.addEventListener("input", function () {
      drop.style.display = "block";
      renderDropdown(inp.value);
    });

    // Close on click outside
    document.addEventListener("click", function (e) {
      if (!inp.contains(e.target) && !drop.contains(e.target)) {
        drop.style.display = "none";
        if (CN[country]) inp.value = CN[country];
      }
    });
  }

  function addBusinessDays(startDate, days) {
    var d = new Date(startDate);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return d;
  }

  function fmtDate(d) {
    return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
  }

  function getNextBatchDispatchDate(date) {
    var now = new Date(date);
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();

    var target;
    if (day <= 15) {
      target = new Date(year, month, 15);
    } else {
      target = new Date(year, month + 1, 1);
    }

    if (target.getDay() === 6) {
      target.setDate(target.getDate() + 2);
    } else if (target.getDay() === 0) {
      target.setDate(target.getDate() + 1);
    }

    return target;
  }

  function paintEta() {
    var tr = transit(country), e = document.getElementById("tketa"); if (!e) return;
    var now = new Date();
    var dispatchDate = getNextBatchDispatchDate(now);
    var arriveMinDate = addBusinessDays(dispatchDate, Math.max(1, tr[0]));
    var arriveMaxDate = addBusinessDays(dispatchDate, Math.max(2, tr[1]));
    var arriveStr = fmtDate(arriveMinDate) + " – " + fmtDate(arriveMaxDate);
    var destName = (country && CN[country]) ? CN[country] : "your country";

    e.innerHTML =
      '<div style="background:#fafafa;border:1.5px solid #e4e4e7;border-radius:8px;padding:9px 12px;font-size:13px;line-height:1.45;color:#09090b;margin-top:2px;">' +
        '<div>🚚 <b>Yes we ship to ' + destName + '</b>, we ship out <b>1st &amp; 15th</b>,<br/>you\'ll receive it by <b style="color:#EB172B;font-weight:900;">' + arriveStr + '</b>.</div>' +
        '<div style="font-size:11.5px;color:#71717a;margin-top:3px;">💡 <i>We save on operations and share the savings with you!</i></div>' +
      '</div>';
  }

  function paintRateButtons() {
    var box = document.getElementById("tkrates"); if (!box) return;
    box.innerHTML = "";
    var rates = [
      { label: "1/wk", val: 1 },
      { label: "2-3/wk", val: 3 },
      { label: "4-5/wk", val: 5 },
      { label: "Daily (7/wk)", val: 7 }
    ];
    rates.forEach(function (r) {
      var btn = document.createElement("button");
      btn.textContent = r.label;
      var on = (r.val === patchesPerWeek) || (r.val === 3 && (patchesPerWeek === 2 || patchesPerWeek === 3));
      btn.style.cssText = "font-size:11.5px;padding:5px 9px;border-radius:6px;cursor:pointer;transition:all 0.15s ease;" + (on ? "background:#EB172B;color:#ffffff;font-weight:800;border:1.5px solid #EB172B;" : "background:#ffffff;color:#18181b;font-weight:600;border:1.5px solid #e4e4e7;");
      btn.addEventListener("click", function () {
        patchesPerWeek = r.val;
        var customInp = document.getElementById("tkcustom");
        if (customInp) customInp.value = patchesPerWeek;
        paintRateButtons();
        paintSupplyButtons();
        autoSelectTierBySupply(selectedSupplyMonths);
      });
      box.appendChild(btn);
    });
    paintSupplyButtons();
  }

  var selectedSupplyMonths = 3;

  function paintSupplyButtons() {
    var box = document.getElementById("tksupplies"); if (!box) return;
    box.innerHTML = "";
    var supplies = [
      { label: "1 Month", mos: 1 },
      { label: "3 Months", mos: 3 },
      { label: "6 Months", mos: 6 },
      { label: "1 Year (Max Savings)", mos: 12 }
    ];
    supplies.forEach(function (s) {
      var btn = document.createElement("button");
      btn.textContent = s.label;
      var on = s.mos === selectedSupplyMonths;
      btn.style.cssText = "font-size:11.5px;padding:5px 9px;border-radius:6px;cursor:pointer;transition:all 0.15s ease;" + (on ? "background:#09090b;color:#ffffff;font-weight:800;border:1.5px solid #09090b;" : "background:#ffffff;color:#18181b;font-weight:600;border:1.5px solid #e4e4e7;");
      btn.addEventListener("click", function () {
        selectedSupplyMonths = s.mos;
        autoSelectTierBySupply(s.mos);
        paintSupplyButtons();
      });
      box.appendChild(btn);
    });
  }

  function autoSelectTierBySupply(mos) {
    if (!data || !data.tiers) return;
    var monthly = patchesPerWeek * (52 / 12);
    var targetPieces = mos * monthly;
    var bestIdx = 0;
    var bestDiff = Infinity;
    data.tiers.forEach(function (t, i) {
      var diff = Math.abs(t.pieces - targetPieces);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestIdx = i;
      }
    });
    activeTierIndex = bestIdx;
    try {
      if (data.tiers[bestIdx] && data.tiers[bestIdx].id) {
        window.history.replaceState(null, '', '?variant=' + data.tiers[bestIdx].id);
      }
    } catch (e) {}
    paintTiers();
    syncTiers();
  }

  var orderQuantity = 1;

  function getSupplyDurationText(pieces, qty) {
    var totalPieces = pieces * (qty || 1);
    var monthly = patchesPerWeek * (52 / 12);
    var mos = totalPieces / monthly;
    if (mos < 1) {
      return "~" + Math.round(mos * 30) + " days supply";
    } else {
      return "~" + mos.toFixed(1) + " mos supply";
    }
  }

  function getPillInfo(t, gpp, bands, c) {
    if (!t) return { title: "", sub: "", isFree: false, per: 0, total: 0, price: 0, ship: 0, supplyText: "" };
    var vName = t.variant || "";
    var isTouku = /touku/i.test(window.location.pathname) || (data && /touku/i.test(data.slug || data.product_title || ""));
    var isFree = isTouku && (t.price_sgd >= freeShippingMin);
    var ship = isFree ? 0 : shipFor(t.pieces * gpp, bands, c);
    var total = t.price_sgd + ship;
    var per = total / t.pieces;
    var supplyText = getSupplyDurationText(t.pieces, 1);

    var title = t.variant ? t.variant.split(' - ')[0] : (t.pieces + " " + UNITS);
    if (/1\s*pack\b/i.test(vName)) title = "1 Pack (5 pcs)";
    else if (/3\s*packs\b/i.test(vName)) title = "3 Packs (15 pcs)";
    else if (/10\s*packs\b/i.test(vName)) title = "10 Packs (50 pcs)";
    else if (/25\s*packs\b/i.test(vName)) title = "25 Packs (125 pcs)";
    else if (/1\s*box\b/i.test(vName) || /100\s*packs\b/i.test(vName)) title = "1 Box (500 pcs)";

    var badge = isFree ? (t.pieces >= 500 ? "Save $200" : "Free Ship") : supplyText;

    return { title: title, badge: badge, isFree: isFree, per: per, total: total, ship: ship, price: t.price_sgd, supplyText: supplyText };
  }

  function paintTiers() {
    var box = document.getElementById("tktiers"); if (!box || !data || !data.tiers) return;
    box.innerHTML = "";
    var gpp = data.grams_per_piece || 8, bands = data.shipping_bands || [];

    data.tiers.forEach(function (t, i) {
      var info = getPillInfo(t, gpp, bands, country);
      var on = i === activeTierIndex;

      var btn = document.createElement("button");
      btn.innerHTML =
        '<div style="font-weight:800;font-size:12px;line-height:1.2;">' + info.title + '</div>' +
        '<div style="font-size:11px;margin-top:2px;' + (on ? 'color:#ffffff;' : (info.isFree ? 'color:#EB172B;font-weight:700;' : 'color:#71717a;')) + '">' +
          'S$' + info.price.toFixed(2) + ' • ' + info.badge +
        '</div>';

      btn.style.cssText = "flex:1;min-width:130px;padding:7px 8px;border-radius:8px;cursor:pointer;text-align:center;transition:all 0.15s ease;" +
        (on ? "background:#EB172B;color:#ffffff;border:1.5px solid #EB172B;box-shadow:0 2px 8px rgba(235,23,43,0.25);" : "background:#ffffff;color:#18181b;border:1.5px solid #e4e4e7;");

      btn.addEventListener("click", function () {
        activeTierIndex = i;
        try {
          if (t.id) window.history.replaceState(null, '', '?variant=' + t.id);
        } catch (e) {}
        var monthly = patchesPerWeek * (52 / 12);
        var mos = t.pieces / monthly;
        var supplies = [1, 3, 6, 12];
        var bestS = 3;
        var bestSDiff = Infinity;
        supplies.forEach(function(s) {
          var d = Math.abs(s - mos);
          if (d < bestSDiff) { bestSDiff = d; bestS = s; }
        });
        selectedSupplyMonths = bestS;
        paintSupplyButtons();
        paintTiers();
        syncTiers();
      });
      box.appendChild(btn);
    });
    syncTiers();
  }

  function addToCart(variantId, quantity, isDirectCheckout) {
    if (!variantId) {
      var form = document.querySelector('#AddToCartForm-product-template, form[action*="/cart/add"]');
      if (form) form.submit();
      return;
    }
    var couponCode = el.getAttribute("data-coupon") || (data && data.free_shipping_coupon) || "TOUKUSHIP";
    var curTier = data && data.tiers && data.tiers[activeTierIndex];
    var isEligible = curTier && ((curTier.price_sgd * (quantity || 1)) >= freeShippingMin);

    if (isDirectCheckout) {
      var directUrl = '/cart/' + variantId + ':' + (quantity || 1);
      if (isEligible) directUrl = '/discount/' + encodeURIComponent(couponCode) + '?redirect=/checkout';
      window.location.href = directUrl;
      return;
    }

    var btn = document.getElementById("tk_btn_cart");
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = "⏳ Adding...";
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (btn) {
        btn.innerHTML = "✓ Added to Cart!";
        btn.style.background = "#18181b";
      }
      setTimeout(function () {
        var cartUrl = isEligible 
          ? '/discount/' + encodeURIComponent(couponCode) + '?redirect=/cart'
          : '/cart';
        window.location.href = cartUrl;
      }, 350);
    })
    .catch(function () {
      var fallbackUrl = isEligible 
        ? '/discount/' + encodeURIComponent(couponCode) + '?redirect=/cart/' + variantId + ':' + (quantity || 1)
        : '/cart/' + variantId + ':' + (quantity || 1);
      window.location.href = fallbackUrl;
    });
  }

  function syncTiers() {
    var box = document.getElementById("tktiers"); if (!box || !data || !data.tiers) return;
    var gpp = data.grams_per_piece || 8, bands = data.shipping_bands || [];

    var t = data.tiers[activeTierIndex];
    if (!t) return;
    var info = getPillInfo(t, gpp, bands, country);
    var durationTxt = getSupplyDurationText(t.pieces, orderQuantity);

    if (t.id) syncWithShopifyNativeForm(t.id, t.variant);

    var curTotal = info.price * orderQuantity;
    var couponCode = el.getAttribute("data-coupon") || (data && data.free_shipping_coupon) || "TOUKUSHIP";
    var banner = document.getElementById("tk_free_banner");
    var bannerTitle = document.getElementById("tk_free_title");
    var bannerSub = document.getElementById("tk_free_sub");

    if (banner && bannerTitle && bannerSub) {
      if (curTotal >= freeShippingMin) {
        banner.style.background = "#f0fdf4";
        banner.style.borderColor = "#16a34a";
        bannerTitle.style.color = "#16a34a";
        bannerTitle.innerHTML = "⚡ FREE Worldwide Tracked Shipping Unlocked!";
        bannerSub.innerHTML = "✓ <i>Code <b>" + couponCode + "</b> is automatically applied at checkout — 100% free shipping!</i>";
      } else {
        banner.style.background = "#fff5f5";
        banner.style.borderColor = "#EB172B";
        bannerTitle.style.color = "#EB172B";
        bannerTitle.innerHTML = "⚡ FREE Worldwide Tracked Shipping (Orders over S$" + Math.round(freeShippingMin) + ")";
        bannerSub.innerHTML = "✨ <i>Code <b>" + couponCode + "</b> will be automatically applied at checkout when order reaches S$" + Math.round(freeShippingMin) + ".</i>";
      }
    }

    var out = document.getElementById("tkcost");
    if (out) {
      var totalLinePrice = (info.price * orderQuantity).toFixed(2);
      var shipNote = info.isFree
        ? '<span style="color:#EB172B;font-weight:700;">FREE Worldwide Shipping</span>'
        : '<span>+ S$' + (info.ship * orderQuantity).toFixed(2) + ' shipping</span>';

      var friendTip = info.isFree
        ? '<div style="font-size:11.5px;color:#166534;background:#f0fdf4;border:1px solid #bbf7d0;padding:6px 10px;border-radius:6px;margin-top:6px;">👥 <b>Buying with a friend or training partner?</b> Free tracked shipping included — share and split the savings!</div>'
        : '<div style="font-size:11.5px;color:#52525b;background:#fafafa;border:1px solid #e4e4e7;padding:6px 10px;border-radius:6px;margin-top:6px;">👥 <b>Buying with a friend?</b> Combine your order to reach 25 Packs to unlock <b>FREE Worldwide Shipping</b> together!</div>';

      out.innerHTML =
        '<div style="margin-top:6px;font-size:13px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:4px;">' +
          '<div><b>S$' + info.per.toFixed(2) + '/' + UNIT + '</b> landed (S$' + totalLinePrice + ' • ' + shipNote + ')</div>' +
          '<div style="font-size:12.5px;color:#09090b;font-weight:700;">🗓️ ' + durationTxt + ' (at ' + patchesPerWeek + '/wk)</div>' +
        '</div>' +
        friendTip;
    }

    var cta = document.getElementById("tkcta");
    if (cta) {
      var finalGoodsPrice = (info.price * orderQuantity).toFixed(2);
      cta.innerHTML =
        '<div style="display:flex;gap:8px;align-items:center;width:100%;flex-wrap:wrap;">' +
          '<div style="display:inline-flex;align-items:center;border:1.5px solid #e4e4e7;border-radius:8px;background:#ffffff;height:44px;">' +
            '<button id="tk_qty_minus" type="button" style="width:32px;height:100%;border:none;background:transparent;cursor:pointer;font-size:16px;font-weight:800;color:#18181b;">−</button>' +
            '<input id="tk_qty_val" type="number" min="1" max="100" value="' + orderQuantity + '" style="width:36px;height:100%;border:none;text-align:center;font-size:13px;font-weight:800;color:#09090b;-moz-appearance:textfield;" />' +
            '<button id="tk_qty_plus" type="button" style="width:32px;height:100%;border:none;background:transparent;cursor:pointer;font-size:16px;font-weight:800;color:#18181b;">+</button>' +
          '</div>' +
          '<button id="tk_btn_cart" type="button" style="flex:2;min-width:160px;height:44px;background:#EB172B;color:#ffffff;font-weight:900;font-size:13.5px;padding:0 14px;border:none;border-radius:8px;cursor:pointer;box-shadow:0 4px 12px rgba(235,23,43,0.3);letter-spacing:0.3px;text-transform:uppercase;font-style:italic;">' +
            '🛒 Add ' + (orderQuantity > 1 ? orderQuantity + 'x ' : '') + info.title + ' — S$' + finalGoodsPrice +
          '</button>' +
          '<button id="tk_btn_buy" type="button" style="flex:1;min-width:115px;height:44px;background:#09090b;color:#ffffff;font-weight:900;font-size:13px;padding:0 12px;border:none;border-radius:8px;cursor:pointer;box-shadow:0 4px 12px rgba(0,0,0,0.15);letter-spacing:0.3px;text-transform:uppercase;font-style:italic;">' +
            '⚡ Buy with Shop' +
          '</button>' +
        '</div>';

      var minusBtn = document.getElementById("tk_qty_minus");
      var plusBtn = document.getElementById("tk_qty_plus");
      var qtyInp = document.getElementById("tk_qty_val");

      if (minusBtn) minusBtn.addEventListener("click", function () {
        if (orderQuantity > 1) {
          orderQuantity--;
          syncTiers();
        }
      });
      if (plusBtn) plusBtn.addEventListener("click", function () {
        orderQuantity++;
        syncTiers();
      });
      if (qtyInp) qtyInp.addEventListener("change", function () {
        var v = parseInt(qtyInp.value, 10);
        if (v && v >= 1) {
          orderQuantity = v;
          syncTiers();
        }
      });

      var btnCart = document.getElementById("tk_btn_cart");
      if (btnCart) btnCart.addEventListener("click", function () { addToCart(t.id, orderQuantity, false); });

      var btnBuy = document.getElementById("tk_btn_buy");
      if (btnBuy) btnBuy.addEventListener("click", function () { addToCart(t.id, orderQuantity, true); });
    }
  }

  function paintShip() {
    var out = document.getElementById("tkship"); if (!out || !data) return;
    var t = (data.tiers || [])[0], bands = data.shipping_bands || [];
    var price = t ? t.price_sgd : 0;
    var isTouku = /touku/i.test(window.location.pathname) || (data && /touku/i.test(data.slug || data.product_title || ""));
    if (isTouku && price >= freeShippingMin) {
      out.innerHTML = "⚡ <b style=\"color:#EB172B;\">FREE worldwide tracked shipping</b> on this order (over S$" + Math.round(freeShippingMin) + ").";
      return;
    }
    var ship = t ? shipFor(t.grams || data.grams_per_piece || 0, bands, country) : null;
    var shipTxt = ship == null ? "Standard tracked shipping" : "Delivery: <b>S$" + ship + " flat</b>";
    out.innerHTML = shipTxt + " (Tracked from Singapore).";
  }

  syncShopifyNavigation();
})();
